import React from 'react';
import Table from 'react-bootstrap/Table';
import BaseProps from '../../../types/BaseProps';
import {ObjectPropertyDetails} from '../../../types/Object';
import classNames from "classnames";
import {resolvePropertyVisualization} from "../properties/object-property-view-resolver";

export type PropertiesSectionProps = BaseProps & {
  propertiesData: Array<ObjectPropertyDetails>;
};

/**
 * A component wrapping Table as base component intended to show the information about properties of objects.
 */
export default class ObjectPropertiesView extends React.Component<PropertiesSectionProps> {

  render() {
    const classes = classNames("ObjectPropertiesView", this.props.className);
    return (
      <div className={classes}>
        <Table hover={true} bordered={true}>
          <tbody>
          {this.props.propertiesData.map((prop: ObjectPropertyDetails, index: number) => (
            <PropertyRow key={index} property={prop}/>
          ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

const PropertyRow = (props: { property: ObjectPropertyDetails }) => {
  const property = props.property;
  const visualization = resolvePropertyVisualization(property);
  return (
    <tr key={property.name} property-name={property.name}>
      <td className="property-label">
        <b>{property.label || property.name}</b>
        <sup> {props.property.type}</sup>
      </td>
      <td className="property-value">{visualization}</td>
    </tr>
  );
};
